import React from 'react'

export interface ViewSidebarProps {
  children?: React.ReactNode
}

const ViewSidebar: React.FC<ViewSidebarProps> = (props) => {
  const { children } = props

  return <div>{children}</div>
}

export default ViewSidebar
